import { useRef } from 'react'

import { useAPISauceCreateWithAuth } from '@flowwai-frontend/shared/auth/common'

import { LogoutServiceAPI } from '../../services/LogoutService/index.api'

const useLogoutService = (): LogoutServiceAPI => {
   const create = useAPISauceCreateWithAuth()

   const logoutServiceRef = useRef(new LogoutServiceAPI(create))

   return logoutServiceRef.current
}

export { useLogoutService }
